export const imagePath = (image: string) => {
  if (image.startsWith('http')) {
    return image;
  }
  const path = process.env.NEXT_PUBLIC_STRAPI_IMAGES;
  if (path && path.length) {
    return path + image;
  }
  return image;
};